export default modalName => {
  const showAction = data => ({
    type: 'SHOW_MODAL',
    modalName,
    data,
  });

  const hideAction = data => ({
    type: 'HIDE_MODAL',
    modalName,
    data,
  });

  return {
    showAction,
    hideAction,
  };
};
